/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Prenatal_Massage_TermsInputs */

const en_service_type_prenatal_massage_terms = /** @type {(inputs: Service_Type_Prenatal_Massage_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pregnancy massage, prenatal`)
};

const pl_service_type_prenatal_massage_terms = /** @type {(inputs: Service_Type_Prenatal_Massage_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`masaż w ciąży, ciąża, masaż prenatalny`)
};

/**
* | output |
* | --- |
* | "pregnancy massage, prenatal" |
*
* @param {Service_Type_Prenatal_Massage_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_prenatal_massage_terms = /** @type {((inputs?: Service_Type_Prenatal_Massage_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Prenatal_Massage_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_prenatal_massage_terms(inputs)
	return en_service_type_prenatal_massage_terms(inputs)
});